/**
 * Maps Dejavoo registrationProgress messages to a 0–1 bar value (best-effort).
 * @param {string} message
 * @returns {{ value: number|null, indeterminate: boolean }}
 */
export function mapIphoneTopProgressMessage (message) {
  const m = String(message || '').toLowerCase()
  if (!m) {
    return { value: null, indeterminate: true }
  }
  if (m.includes('download')) {
    return { value: 0.25, indeterminate: false }
  }
  if (m.includes('parameter') || m.includes('configur')) {
    return { value: 0.5, indeterminate: false }
  }
  if (m.includes('merchant') || m.includes('accept') || m.includes('terms')) {
    return { value: 0.75, indeterminate: false }
  }
  if (m.includes('ready') || m.includes('complete')) {
    return { value: 1, indeterminate: false }
  }
  return { value: null, indeterminate: true }
}
